import { z } from 'my-zod'
import { vehicleUseHistoryBaseFragment, vehicleUseHistorySuperRefine } from './vehicle-use-history-base-fragment'

export const vehiclePrepSchema = vehicleUseHistoryBaseFragment
  .extend({
    customAssetFamilyId: z.number().nullable()
  })
  .superRefine((values, ctx) => {
    if (!values.customAssetFamilyId) {
      vehicleUseHistorySuperRefine(values, ctx)
    }
  })

export const vehicleCheckOutSchema = vehicleUseHistoryBaseFragment
  .extend({
    vehicleId: z.number(),
    driverRiderId: z.string(),
    safetyChecklist: z.object({ checked: z.boolean() }).array(),
    safetyChecklistLength: z.number(),
    checkOutCustomerBase64Signature: z.string().min(1, 'Required'),
    checkOutStaffBase64Signature: z.string().min(1, 'Required'),
    waiverContentId: z.string().nullable(),
    customAssetFamilyId: z.number().nullable()
  })
  .superRefine((values, ctx) => {
    if (!values.customAssetFamilyId) {
      vehicleUseHistorySuperRefine(values, ctx)
    }

    if (values.safetyChecklistLength) {
      const { safetyChecklist: list, safetyChecklistLength: listLength } = values
      const allSelected = list.length === listLength && Object.values(list).every((val) => val.checked)
      if (!allSelected) {
        ctx.addIssue({
          message: 'Select all',
          code: z.ZodIssueCode.custom,
          path: ['safetyChecklist']
        })
      }
    }
  })

export const vehicleCheckInSchema = vehicleUseHistoryBaseFragment
  .extend({
    vehicleId: z.number(),
    checkInDidCustomerHitAnything: z.enum(['yes', 'no']).nullable(),
    checkInDidVehicleHaveMechanicalOrElectricalIssue: z.enum(['yes', 'no']).nullable(),
    customerMachineRanOk: z.enum(['yes', 'no']).nullable(),
    checkInCustomerBase64Signature: z.string().min(1, 'Required'),
    checkInStaffBase64Signature: z.string().min(1, 'Required'),
    checkInTime: z.string().min(1, 'Required'),
    checkInDate: z.string().min(1, 'Required'),
    checkInDateTime: z.string(),
    customAssetFamilyId: z.number().nullable()
  })
  .superRefine((values, ctx) => {
    if (!values.customAssetFamilyId) {
      vehicleUseHistorySuperRefine(values, ctx)
      if (!values.checkInDidCustomerHitAnything) {
        ctx.addIssue({
          message: 'Required',
          code: z.ZodIssueCode.custom,
          path: ['checkInDidCustomerHitAnything']
        })
      }
      if (!values.customerMachineRanOk) {
        ctx.addIssue({
          message: 'Required',
          code: z.ZodIssueCode.custom,
          path: ['customerMachineRanOk']
        })
      }
      if (!values.checkInDidVehicleHaveMechanicalOrElectricalIssue) {
        ctx.addIssue({
          message: 'Required',
          code: z.ZodIssueCode.custom,
          path: ['checkInDidVehicleHaveMechanicalOrElectricalIssue']
        })
      }
    }

    if (values.checkInDate && values.checkInTime && !(values.checkInDateTime?.length > 1)) {
      ctx.addIssue({
        message: 'Required',
        code: z.ZodIssueCode.custom,
        path: ['checkInDateTime']
      })
    }
  })
